import type { Domain } from '@/config/domain/type';

export const trademarksOnlineSingapore: Domain = {
    domain: import.meta.env.VITE_TMO_SG_DOMAIN,
    website: 'https://www.trademarksonline.com.sg',
    shortCode: 'tmo-sg',
    markSource: 'TMOV2-SG',
    title: 'Apply for your Singapore trademark',
    name: 'Trademarks Online Singapore',
    description: 'Our online trademark registration platform is available 24/7 and takes just minutes. Apply for your Singapore trademark by entering your trademark or logo.',
    logo: '/img/TM-Logo-SG.png',
    menuItems: [
        { label: 'Home', url: '' },
        { label: 'Pricing', url: '/pricing' },
        { label: 'FAQ', url: '/faq' },
        { label: 'About', url: '/contact' },
    ],
    footerItems: [
        { label: 'Privacy Policy', url: '/privacy-policy' },
        { label: 'Terms of Use', url: '/terms-of-use' },
        { label: 'Contact Us', url: '/contact' },
    ],
    termOfUseUrl: '/terms-of-use',
    bannerImageUrl: '/img/TMO-Banner-SG-XL.png',
    gtmId: 'GTM-5MC6GKWP',
};
